import NormalFarmService from './normal-farm.service';

export default class FarmPoolsService {
  normalFarm: NormalFarmService;

  constructor() {
    this.normalFarm = new NormalFarmService();
  }
}

export const poolsService = new FarmPoolsService();
